import { MarketingCenterColorSchemeDictionary } from '../colorScheme';
import {
  ICanvasElement,
  ICanvasElementDrawArgs
} from '@/models/marketingCenter/canvas';
import { cover } from '@/utils/canvas';

class BackgroundImageCanvasElement implements ICanvasElement {
  constructor(
    private readonly options: {
      image?: string;
    }
  ) {}

  showOnPreview = true;

  async draw(context: CanvasRenderingContext2D, args: ICanvasElementDrawArgs) {
    if (!args.color) return;
    const { image } = this.options;

    await this.drawSolid(context, args);

    if (image) {
      const imageUrl = require(`../../../assets/img/${image}`);
      await this.drawImage(imageUrl, context, args);
    }
  }

  drawImage(
    url: string,
    context: CanvasRenderingContext2D,
    args: ICanvasElementDrawArgs
  ) {
    return new Promise<void>((resolve, reject) => {
      try {
        const image = new Image();
        image.onerror = reject;
        image.onload = () => drawImageActualSize();
        image.src = url;

        const drawImageActualSize = () => {
          if (!context) return;

          const { offsetX, offsetY, width, height } = cover(
            args.canvas.width,
            args.canvas.height,
            image.naturalWidth,
            image.naturalHeight
          );

          context.drawImage(image, offsetX, offsetY, width, height);

          resolve();
        };
      } catch (e) {
        reject(e);
      }
    });
  }

  drawSolid(context: CanvasRenderingContext2D, args: ICanvasElementDrawArgs) {
    return new Promise<void>((resolve, reject) => {
      try {
        const color = MarketingCenterColorSchemeDictionary[args.color];
        context.fillStyle = color.primary;
        context.fillRect(0, 0, args.canvas.width, args.canvas.height);
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }
}

export default BackgroundImageCanvasElement;
